import { PATHS } from "src/routes/paths";


export const getPathAfterLogin = (role) => {
  switch (role) {
    case "hotel":
      return PATHS.hotel.root;
    case "shop":
      return PATHS.shop.root;
    case "voucherAdmin":
      return PATHS.voucherAdmin.root;
    case "operator":
      return PATHS.dashboard.myListings;
    case "company": 
      return PATHS.dashboard.myListings;
    case "admin": 
      return PATHS.dashboard.myListings;
    default:
      return PATHS.listings.list;
  }
};